import {
  ICreateMotivoNoEntrega,
  IUpdateMotivoNoEntrega,
} from '../../interfaces/motivo-no-entrega.interface';

export namespace MotivoNoEntregaActions {
  export class GetMotivos {
    static readonly type = '[MotivoNoEntrega] Get Motivos';
    constructor(
      public page?: number,
      public pageSize?: number,
    ) {}
  }
  export class CreateMotivo {
    static readonly type = '[MotivoNoEntrega] Create Motivo';
    constructor(public dto: ICreateMotivoNoEntrega) {}
  }
  export class UpdateMotivo {
    static readonly type = '[MotivoNoEntrega] Update Motivo';
    constructor(
      public id: number,
      public dto: IUpdateMotivoNoEntrega,
    ) {}
  }
  export class DeleteMotivo {
    static readonly type = '[MotivoNoEntrega] Delete Motivo';
    constructor(public id: number) {}
  }
}
